import { Tour } from '../api/types';
import { Lang } from './LanguageContext';

/** Restituisce i campi del tour risolti nella lingua richiesta, con fallback all'italiano. */
export function resolveTour(tour: Tour, lang: Lang) {
  const en = lang === 'en';
  const pick = (it?: string, enVal?: string) => (en && enVal && enVal.trim() ? enVal : (it || ''));
  const pickList = (it: string[], enVal?: string[]) => (en && enVal && enVal.length ? enVal : (it || []));
  return {
    title: pick(tour.title, tour.titleEn),
    subtitle: pick(tour.subtitle, tour.subtitleEn),
    description: pick(tour.description, tour.descriptionEn),
    included: pickList(tour.included, tour.includedEn),
    notIncluded: pickList(tour.notIncluded, tour.notIncludedEn),
  };
}
